import { render } from "./mat-radio-group.vue?vue&type=template&id=4c1681b7&lang=true"
import script from "./mat-radio-group.vue?vue&type=script&lang=js"
export * from "./mat-radio-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__